import { EntityModificationTrace, FreeData, FreeDataValue } from '@wizeoo/akm-message-lib';
import { ViewData } from '../../model/view.data';

/**
 * objet porteur du pack de FD/ FDVs chargés
 */
export class FreedataDataload {
  public static PENDING: string = 'PENDING';
  public static LOADING: string = 'LOADING';
  public static COMPLETE: string = 'COMPLETE';

  public domain: string; // pour contrôle de cohérence sur chargement
  public bu: string; // pour contrôle de cohérence sur chargement
  public uniqueKey: string; // domain|bu

  public state: string = FreedataDataload.PENDING; // l'état de chargement de ce pool

  public revisionNumber: number = -1; // dernier numRev local
  public nbFds: number = 0; // nombre de fds
  public nbFdvs: number = 0; // nombre de fdvs
  public nbDeleteds: number = 0; // nombre de suppressions FD / FDV
  
  public localFds: Map<string, FreeData> = new Map(); // les fds stockées en indexDB

  public remoteRevisionNumber: number = -1; // le numRev remote, retourné lors du count

  public freedatas: FreeData[] = []; // les fds à charger
  public freedataValues: FreeDataValue[] = []; // les fdvs à charger

  public deletedFds: EntityModificationTrace[]; // EMs de suppression sur fds
  public deletedFdvs: EntityModificationTrace[]; // EMs de suppression sur fdvs
  public callbacks: Function[] = []; //  fonctions de retour, va renvoyer les localFds (freedatas: FreeData[]) => void; // 

  public freedataCode: string = null; // pour appel sur un seul FD avant commit, pour contrôle d'intégrité

  constructor(domain: string, bu: string, freedataCode?: string ) {
    this.domain = domain;
    this.bu =bu;
    this.freedataCode = freedataCode;
    this.uniqueKey = domain + ViewData.KEY_SEPARATOR + bu;
   }

   public toPersist: Map<string, FreeData> = null;
   public toDie: Map<number, EntityModificationTrace> = null;

}
